import * as Yup from 'yup';
import moment from 'moment';

import { Tab } from '@/components/Tabs/Tabs.types';
import { OptionType } from '@/typings/common';

import { AlfaLeasingQuizFieldsType, AlfaLeasingQuizFieldType } from './types';

export const questions: string[] = [
  'Ваша дата рождения?',
  'Дата начала работы на последнем месте работы?',
  'Гражданство',
  'Среднемесячный доход в BYN',
  'Были ли просрочки по кредитам, лизингу, рассрочкам\n' +
    'более 30 дней и более 300 BYN за последние 12 месяцев?',
];

export const tabsData: Tab[] = [
  { label: 'Нет', value: 'Нет' },
  { label: 'Да', value: 'Да' },
];

export const selectData: OptionType[] = [
  {
    value: 'citizenRB',
    label: 'Гражданин РБ',
  },
  {
    value: 'residencePermitRB',
    label: 'Вид на жительство в РБ',
  },
  {
    value: 'otherCitizenship',
    label: 'Иное гражданство',
  },
];

export const initialAlfaLeasingQuizValues: AlfaLeasingQuizFieldsType = {
  birthdate: '',
  lastJobAt: '',
  isBelarus: false,
  averageIncome: 0,
  haveDebts: false,
};

export const validationBirthday: Yup.SchemaOf<AlfaLeasingQuizFieldType> =
  Yup.object().shape({
    birthdate: Yup.string()
      .required('Укажите дату рождения')
      .min(10, 'Введите дату')
      .test('18 years old', 'К сожалению Вам нет 18 лет', (value) => {
        return (
          Math.floor(
            moment(new Date()).diff(moment(value, 'DD/MM/YYYY'), 'years', true)
          ) >= 18
        );
      }),
  });

export const validationLastJob: Yup.SchemaOf<AlfaLeasingQuizFieldType> =
  Yup.object().shape({
    lastJobAt: Yup.string()
      .required('Укажите дату начала работы')
      .min(10, 'Введите дату'),
  });

export const validationNationality: Yup.SchemaOf<AlfaLeasingQuizFieldType> =
  Yup.object().shape({
    isBelarus: Yup.boolean().required('Укажите гражданство'),
  });

export const validationAverageIncome: Yup.SchemaOf<AlfaLeasingQuizFieldType> =
  Yup.object().shape({
    averageIncome: Yup.number().required('Укажите среднемесячный доход'),
  });

export const validationDebts: Yup.SchemaOf<AlfaLeasingQuizFieldType> =
  Yup.object().shape({
    haveDebts: Yup.boolean().required('Укажите были ли просрочки'),
  });
